import React from "react";
import { useI18n } from "../i18n";

export default function LegalPage({ ns, testid }) {
  const { t, tArr } = useI18n();
  const sections = tArr(`${ns}.sections`);
  return (
    <main className="bg-white pt-28 pb-20 md:pt-32 md:pb-24" data-testid={testid}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="inline-block text-xs font-bold uppercase tracking-widest text-emerald-800 bg-emerald-50 px-3 py-1 rounded border border-emerald-200">
          Saverondelio · {t("header.badge")}
        </span>
        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 mt-4">
          {t(`${ns}.title`)}
        </h1>
        <p className="mt-2 text-sm text-slate-500">{t(`${ns}.updated`)}</p>

        <div className="mt-10 space-y-8">
          {sections.map((s, i) => (
            <section key={i} data-testid={`${testid}-section-${i}`}>
              <h2 className="font-heading text-xl sm:text-2xl font-semibold text-slate-900">{s.heading}</h2>
              <p className="mt-3 text-slate-700 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
